module.exports = "<p>\r\n  auto-complete-filter-modal works!\r\n</p>\r\n"